import script from "./CreateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=5a6951a6&scoped=true&lang=css"
import "./CreateForm.vue?vue&type=style&index=1&id=5a6951a6&lang=css"
import "./CreateForm.vue?vue&type=style&index=2&id=5a6951a6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6951a6"]])

export default __exports__